import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var MinusCircle = function MinusCircle(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 16 16' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0.533333333 C3.87644444,0.533333333 0.533333333,3.87644444 0.533333333,8 C0.533333333,12.1235556 3.87644444,15.4666667 8,15.4666667 C12.1235556,15.4666667 15.4666667,12.1235556 15.4666667,8 C15.4666667,3.87644444 12.1235556,0.533333333 8,0.533333333 Z M12.4444444,8.88888889 L3.55555556,8.88888889 L3.55555556,7.11111111 L12.4444444,7.11111111 L12.4444444,8.88888889 Z"
  })));
};

MinusCircle.displayName = 'MinusCircle';
export default MinusCircle;